export default __webpack_public_path__ + "static/media/Congestive-Heart-Failure-2.f3065333.jpg";